<template>
    <div class="pm-gallery-group renderfix">
        <div class="pm-gallery-group-header renderfix">
            <span style="font-weight: 600; flex-grow: 1;" class="">{{ title }}</span>
        </div>
        <div class="pm-gallery-group-items renderfix" style="margin-top: 0px;">
            <error-boundary v-for="item in items" :key="item.id" v-once>
                <pm-gallery-item v-once :settings="item" />
            </error-boundary>
        </div>
    </div>
</template>
<style>
    .pm-gallery-group {
        background: #F8F8F8;
        padding: 0 0 20px 0;
    }
    .pm-gallery-group-header {
        display: flex;
        font-size: 14px;
        text-transform: none;
        background: rgb(255, 255, 255);
        padding: 16px 16px 0px 16px;
    }
    .pm-gallery-group-items {
        display: grid;
        gap: 20px;
        background: rgb(255, 255, 255);
        box-shadow: rgba(0, 150, 0, 0.1) 0px 8px 15px;
        padding: 16px;
    }
    .pm-gallery-grid-4 .pm-gallery-group-items {
        grid-template-columns: repeat(4, calc(25vw - 24px));
    }
    .pm-gallery-grid-3 .pm-gallery-group-items {
        grid-template-columns: repeat(3, 28%);
    }
    .pm-gallery-grid-2 .pm-gallery-group-items {
        grid-template-columns: repeat(2, 46%);
    }
    .pm-gallery-grid-1 .pm-gallery-group-items {
        grid-template-columns: repeat(1, 1fr);
    }
    @media (min-width: 700px) {
        .pm-gallery-group-header {
            font-size: 18px;
        }
    }
</style>
<script>
import childCategories from "../../configs/gallery/child-categories.json";
import PmGalleryItem from "./group-item";
import mixinComputedTitle from "./mixin-computed-title";
import ErrorBoundary from "@/components/core/error-boundary";
export default {
    components: {
        ErrorBoundary,
        PmGalleryItem,
    },
    mixins: [
        mixinComputedTitle
    ],
    props: {
        settings: {
            type: Object,
        },
    },
    data() {
        return ({
        });
    },
    computed: {
        items() {
            try {
                const id = parseInt(this.settings.id);
                return childCategories.filter(i => i.parent.includes(this.settings.id)).sort((a,b)=>{
                    if (a.ordering > b.ordering) return 1;
                    if (a.ordering < b.ordering) return -1;
                    return 0;
                });
            } catch(error) {
                captureException(error);
                console.error("Error getting gallery group childs: ", error.message);
                return [];
            }
        },
    }
};
</script>
